import { Flag } from 'common/styles';
import { __t } from '../../i18n';

export default function AgeRestriction({ age }: { age?: string }) {
  return age && age !== 'not_set' ? <Flag my={1}>{__t('content.age.' + age)}</Flag> : null;
}
